import Warning from "@/assets/icons/Warning";
import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import { useT } from "@transifex/react";

interface WarningProps {
  className?: string;
}

const index = ({ className }: WarningProps) => {
  const t = useT();

  return (
    <HStack className={`bg-primary-100 border-warning-300 items-center rounded-[6px] p-[16px] gap-[10px] ${className}`}>
      <Warning fill="text-warning-900" height={20} width={28} />
      <Text className="font-[400] text-[12px] text-warning-900">
        {t("Please note: FlexParks are non-refundable and non-transferable. All sales are final.")}
      </Text>
    </HStack>
  );
};
export default index;
